import React, { useEffect } from 'react';
import { SEO } from '../components/SEO';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { GoogleMapsSection } from '../components/GoogleMapsSection';
import { siteConfig } from '../data/mock';
import { Phone, MapPin, Clock, Instagram } from 'lucide-react';

export const Contato = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO 
        title="Contato Box7go - Lava Jato e Estética Automotiva Goiânia | WhatsApp (62) 98241-6008"
        description="Entre em contato com a Box7go. WhatsApp, telefone, endereço e horários. Estamos em Goiânia para atender você! Lava jato e estética automotiva premium."
        keywords="contato box7go, telefone lava jato goiania, whatsapp box7go, endereço box7go goiania"
      />

      {/* Hero */}
      <section className="bg-gradient-to-br from-black via-gray-900 to-[#00B4D8] py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Entre em Contato
          </h1>
          <p className="text-xl text-white/90 max-w-2xl mx-auto">
            Estamos prontos para atender você. Escolha o canal que preferir!
          </p>
        </div>
      </section>

      {/* Formas de Contato */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
            {/* WhatsApp */}
            <div className="bg-gradient-to-br from-[#25D366] to-[#20BA5A] rounded-xl p-8 text-white text-center shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Phone className="w-8 h-8" />
              </div>
              <h3 className="font-bold text-xl mb-3">WhatsApp</h3>
              <p className="mb-4 text-white/90">Atendimento rápido</p>
              <a
                href={siteConfig.whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-white text-[#25D366] font-semibold px-6 py-2 rounded-lg hover:bg-gray-100 transition-colors"
              >
                (62) 98241-6008
              </a>
            </div>

            {/* Telefone */}
            <div className="bg-gradient-to-br from-[#00B4D8] to-[#0096C7] rounded-xl p-8 text-white text-center shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Phone className="w-8 h-8" />
              </div>
              <h3 className="font-bold text-xl mb-3">Telefone</h3>
              <p className="mb-4 text-white/90">Ligue agora</p>
              <a
                href={`tel:+${siteConfig.phone}`}
                className="inline-block bg-white text-[#00B4D8] font-semibold px-6 py-2 rounded-lg hover:bg-gray-100 transition-colors"
              >
                (62) 98241-6008
              </a>
            </div>

            {/* Instagram */}
            <div className="bg-gradient-to-br from-purple-500 to-pink-500 rounded-xl p-8 text-white text-center shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <Instagram className="w-8 h-8" />
              </div>
              <h3 className="font-bold text-xl mb-3">Instagram</h3>
              <p className="mb-4 text-white/90">Siga-nos</p>
              <a
                href={siteConfig.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-white text-purple-500 font-semibold px-6 py-2 rounded-lg hover:bg-gray-100 transition-colors"
              >
                @box7.go
              </a>
            </div>

            {/* Localização */}
            <div className="bg-gradient-to-br from-gray-800 to-black rounded-xl p-8 text-white text-center shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                <MapPin className="w-8 h-8" />
              </div>
              <h3 className="font-bold text-xl mb-3">Endereço</h3>
              <p className="mb-4 text-white/90">Visite-nos</p>
              <a
                href={siteConfig.googleMaps}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-white text-black font-semibold px-6 py-2 rounded-lg hover:bg-gray-100 transition-colors"
              >
                Ver no Mapa
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Informações Detalhadas */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-xl shadow-lg p-8 md:p-12">
              <h2 className="text-3xl font-bold text-gray-900 mb-8">
                Informações de Contato
              </h2>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#00B4D8]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <Phone className="w-6 h-6 text-[#00B4D8]" />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">Telefone / WhatsApp</h3>
                    <p className="text-gray-600">
                      <a href={`tel:+${siteConfig.phone}`} className="hover:text-[#00B4D8]">
                        (62) 98241-6008
                      </a>
                    </p>
                    <p className="text-sm text-gray-500 mt-1">
                      Atendimento via WhatsApp: Segunda a Sábado
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#00B4D8]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-6 h-6 text-[#00B4D8]" />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">Endereço</h3>
                    <p className="text-gray-600">
                      Jardim Bela Vista<br />
                      Goiânia - GO
                    </p>
                    <a
                      href={siteConfig.googleMaps}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#00B4D8] hover:underline text-sm mt-1 inline-block"
                    >
                      Ver localização no Google Maps →
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#00B4D8]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <Clock className="w-6 h-6 text-[#00B4D8]" />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">Horário de Funcionamento</h3>
                    <div className="text-gray-600 space-y-1">
                      <p><strong>Segunda a Sexta:</strong> 8h às 18h</p>
                      <p><strong>Sábado:</strong> 8h às 17h</p>
                      <p><strong>Domingo:</strong> Fechado</p>
                    </div>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#00B4D8]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <Instagram className="w-6 h-6 text-[#00B4D8]" />
                  </div>
                  <div>
                    <h3 className="font-bold text-gray-900 mb-1">Redes Sociais</h3>
                    <p className="text-gray-600">
                      <a 
                        href={siteConfig.instagram}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:text-[#00B4D8]"
                      >
                        @box7.go
                      </a>
                    </p>
                    <p className="text-sm text-gray-500 mt-1">
                      Acompanhe nossos trabalhos e promoções
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-10 pt-8 border-t border-gray-200">
                <h3 className="font-bold text-gray-900 mb-4 text-center">
                  Prefere agendar pelo WhatsApp?
                </h3>
                <div className="flex justify-center">
                  <WhatsAppButton 
                    text="Iniciar Conversa no WhatsApp"
                    className="text-lg px-8 py-4"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mapa */}
      <GoogleMapsSection />
    </>
  );
};
